module.exports = __webpack_public_path__ + "static/media/Asset8LateralZ2.55e7103b.png";